import React from "react";
export default class CCTM_parse {
    _xmlDOM; // The XML DOM to parse
    _children; // Determines whether to include child nodes in parsing
  _key;
    /**
     * Constructor for CCTM_parse
     * @param {Document} xmlDOM - The XML DOM to parse
     * @param {boolean} children - Whether to include child nodes in parsing
     */
    constructor(xmlDOM, children) {
      this._xmlDOM = xmlDOM;
      this._children = children;
      this._key= 0;
    }
  
    /**
     * Initialize a new CCTM_parse instance with default behavior (no child parsing)
     * @param {Document} xmlDOM - The XML DOM to parse
     * @returns {CCTM_parse} - A new instance of CCTM_parse
     */
    static init(xmlDOM) {
      return new CCTM_parse(xmlDOM, false);
    }
  
    /**
     * Initialize a new CCTM_parse instance with child parsing enabled
     * @param {Document} xmlDOM - The XML DOM to parse
     * @returns {CCTM_parse} - A new instance of CCTM_parse
     */
    static initAll(xmlDOM) {
      return new CCTM_parse(xmlDOM, true);
    }
    static getKey(node) {
      return node.key?? this._key++;
    }
    static getProps(node,isChild,isAsset){
        node = node.attributes ?node:node.props.currentNode;
        const baseProps =isChild?{}: {
            nodeName: node.nodeName,
            currentNode: node,
            key: this.getKey(node)
          };
          let asset = {};
        
          if(node.firstElementChild){
            if(node.firstElementChild.localName=="icon"||node.firstElementChild.localName=="img"){

              asset =node.firstElementChild? this.getProps(node.firstElementChild,false,true)
             
            :{};
        
          }else{
              
                  asset = this.getProps(node.firstElementChild)
              
              
            }
          }
     
         
         
           ;
          // Add attributes of the current node to the properties
         let result =  node.attributes.length !== 0
              ? Object.values(node.attributes).reduce((attributes, {name,value}) => {
               if(isAsset){
                attributes["asset_"+name] = value;
               }else{
                attributes[name] = value;
               }
                  
                  return attributes;
                }, {...asset,...baseProps})
              : baseProps;

              return result;
                
    }
    static getActiveRoutes(node){
      const hasChildren = React.Children.count(node.children) > 0;
      let children =  node.children;
      if(hasChildren){
        children =   node.children[0] ?node.children[0]:node.children;
      }
       
     
      const activeRoutes = hasChildren

          ? React.Children.map(children.props.children, item => {
              if(item.props.children){
               
                return React.isValidElement(item.props.children)?CCTM_parse.getActiveRoutes(item.props):CCTM_parse.getHTMLRoutes(item.props.children[1])
              } 
              if (React.isValidElement(item) && item.props.to !== undefined) {
                  return item.props.to;
              }
          }, [])
          : [node.to ?? ""];
          return activeRoutes;
 
    
              
  }
  static getHTMLRoutes(node){
    const hasChildren = node?.children?.length > 0;
  
       
    const activeRoutes = hasChildren
        ? Array.from(node.children).map( item => {
          if(item.children){
            return CCTM_parse.getHTMLRoutes(item);
          } 
          return item?.attributes?.to?.value;
            
        }, [])
        : [node.attributes?.to?.value ?? ""];
        return activeRoutes;

  
            
}
    /**
     * Getter for `_children`
     * Toggles `_children` to false after use to ensure single-use behavior
     * @returns {boolean} - Whether child nodes are allowed for parsing
     */
    get getChildren() {
      const allowedToGetChildren = this._children;
      this._children = false;
      return allowedToGetChildren;
    }
  
    /**
     * Parses the XML DOM, applying a transformation function to each node
     * @param {Function} transform - The transformation function
     * @param {Array} result - The accumulated result of the transformation
     * @param {Node} node - The current XML node to process
     * @param {Node} parentNode - The parent of the current node
     * @returns {Array} - The result of the parsing
     */
    parse(transform, result, node, parentNode) {
       
      // Start with the first child of the XML DOM if `node` is undefined
      if (node === undefined) {
        node = this._xmlDOM??{};
       
      }
      if (node.nodeType ===  9) {
        node = node.firstChild;
      }
      // Base case: if no node, return the accumulated result
      if (!node) {
        return result;
      }
 
  
      // Apply the transformation function to the current node
      if (typeof transform === "function") {
        result = result ?? [];
  
        // Ignore non-element nodes (e.g., comments, whitespace)
        if (node.nodeType === 1|| node.nodeType ===  9) {
          // Create base properties for the current node
        
  
          // Add attributes of the current node to the properties
          const props =CCTM_parse.getProps(node);

           // Apply the transformation function
           result = transform(result, props, node.childNodes);
      }
   // Recursively process all child nodes if allowed
   if (node.firstChild && this.getChildren) {
    //result = this.parse(transform, result, node.firstChild, node);
  }

  // Process the next sibling node
  if (node.nextSibling && parentNode) {
   //this._children = true; // Reset `_children` for sibling processing
   result = this.parse(transform, result, node.nextSibling, parentNode);
  }
      
      return result;
    }
}
    /**
     * Parses a specific node identified by its ID
     * @param {Function} transform - The transformation function
     * @param {string} id - The ID of the node to parse
     * @param {Node} node - The starting node for the search (optional)
     * @returns {Array} - The result of the parsing
     */
    parseByID(transform, id, node) {
      // Start with the first child of the XML DOM if `node` is undefined
      if (node === undefined) {
        node = this._xmlDOM;
      }
  
      // Find the node by ID or use the given node
      let result = id ? node.querySelectorAll(`#${id}`) : node;
  
      // Initialize a new instance and parse the found node
      return CCTM_parse.init(result[0]).parse(transform, undefined);
    }
  
    /**
     * Parses all nodes identified by the given ID
     * @param {Function} transform - The transformation function
     * @param {string} id - The ID of the nodes to parse
     * @param {Node} node - The starting node for the search (optional)
     * @returns {Array} - The result of the parsing
     */
    parseAllByID(transform, id, node) {
      // Start with the first child of the XML DOM if `node` is undefined
      if (node === undefined) {
        node = this._xmlDOM;
      }
  
      // Find all nodes by ID or use the given node
      let result = id ? node.querySelectorAll(`#${id}`) : node;
  
      // Initialize a new instance with child parsing enabled and parse the nodes
      return CCTM_parse.initAll(result[0]).parse(transform, undefined);
    }
   
}
